export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10221.85ef6a2f.jpg";